import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeValuesOrderRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeType } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type ReorderAttributeValuesVariables = {
    typeId: string;
    body: AttributeValuesOrderRequest;
};

export const useReorderAttributeValuesMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeType>,
        Error,
        ReorderAttributeValuesVariables
    >({
        mutationFn: ({ typeId, body }) =>
            apiClient.attributeTypes.reorderValues(typeId, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
